import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'editor/src/component/Button';
import IconBin from 'editor/src/component/Icon/IconBin';

import styles from './index.module.scss';

interface Props {
  onRemove: () => void;
  disabled?: boolean;
}

function RemoveImageButton({ onRemove, disabled }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.removeImageButtonWrap}>
      <Button
        secondary
        className={styles.removeImageButton}
        noPadding
        disabled={disabled}
        onClick={onRemove}
        stopPropagation
      >
        <IconBin />
        {t('editor-remove-image')}
      </Button>
    </div>
  );
}

export default React.memo(RemoveImageButton);
